import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import useAccountingSetting from './useAccountingSetting'
import AccountingSettingsTable from './AccountingSettingsTable'
import { FormProvider, useForm } from 'react-hook-form'
import { useZodValidationResolver } from 'util/hooks/useZodValidationResolver'
import type { AccountingSettingFormInputs } from './validation'
import { AccountingSettingFormSchema } from './validation'
import FloatingActionBtn from 'ui/components/FloatingActionBtn'

export const SettingsContainer = styled.div`
	width: 100%;
	height: 80%;
`
export const Header = styled.p`
	margin-top: 1rem;
	margin-bottom: 1rem;
`

const AccountingSettings = () => {
	const intl = useIntl()
	const processing = false
	const { accountingSetting, loading } = useAccountingSetting()

	const resolver = useZodValidationResolver<AccountingSettingFormInputs>(
		AccountingSettingFormSchema,
	)

	const formMethods = useForm<AccountingSettingFormInputs>({
		resolver,
		defaultValues: {},
		mode: 'onBlur',
		shouldUnregister: false,
	})

	const handleSave = async () => {
		// Implement save logic here
	}

	const renderFAB = () => {
		return (
			<FloatingActionBtn
				iconName={processing ? '' : 'save'}
				processing={processing}
				text={
					processing
						? intl.formatMessage({
								defaultMessage: 'Tallennetaan',
								description: 'Saving',
						  })
						: intl.formatMessage({
								defaultMessage: 'Tallenna',
								description: 'Save',
						  })
				}
				action={handleSave}
			/>
		)
	}

	return (
		<SettingsContainer>
			<Header>
				<FormattedMessage
					defaultMessage="Nämä asetukset koskevat automaattista kirjanpitoa. Ruksaa ne osiot, joista haluat Viilun tekevän tositteet kirjanpitoon automaattisesti. Voit määrittää sekä tositelajin että kirjanpitotilin, joita Viilu käyttää oletuksena automaattisesti syntyvillä tositteilla. Jos käytät useampaa myynti- tai ostotiliä, voit esimerkiksi ohjata tietyn asiakkaan myyntilaskut tietylle myyntitille asettamalla tilin ko. asiakaan tietoihin. Se ajaa yli tässä määritetyn oletusasetuksen."
					description="Header text"
				/>
			</Header>
			<Header>
				<FormattedMessage
					defaultMessage="Huom! Muistathan tarkistaa tilikauden alkmais- ja loppumispäivämäärän osiosta Aetukset -> Tilikaudet."
					description="Alert text"
				/>
			</Header>
			<FormProvider {...formMethods}>
				<AccountingSettingsTable
					accountingSetting={accountingSetting}
					loading={loading}
				/>
			</FormProvider>
			{renderFAB()}
		</SettingsContainer>
	)
}

export default AccountingSettings
